import { isMemberOfOrganization } from '../organization/isMemberOfOrganization';
import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';
import { isAdminOfBoard } from './isAdminOfBoard';

/**
 * Checks if a member has permissions to invite new members to the board.
 */
export const canInviteMembers = (
  member: {
    id: string;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  } & {
    idEnterprisesAdmin?: string[] | null;
  },
  board: {
    prefs?: { canInvite: boolean; invitations: 'admins' | 'members' } | null;
    memberships: {
      id: string;
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
  },
  organization?:
    | ({ id: string; offering: string } & {
        enterprise?: { id: string; idAdmins: Array<string> } | null;
        memberships: {
          deactivated: boolean;
          idMember: string;
          memberType: 'admin' | 'normal';
          unconfirmed: boolean;
        }[];
      })
    | null,
): boolean => {
  // If member isn't in workspace, they cannot invite others if the workspace has restricted invites
  if (
    (!organization || !isMemberOfOrganization(member, organization)) &&
    !board.prefs?.canInvite
  )
    return false;

  if (
    board.prefs?.invitations === 'admins' &&
    !(organization && isAdminOfBoard(member, board))
  )
    return false;

  const memberType = getMemberTypeFromBoard(member, board, organization);

  return (
    memberType === 'admin' ||
    (board.prefs?.invitations === 'members' && memberType === 'normal')
  );
};
